import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {useFetchProjectTriggersQuery} from '../../../generated/graphql';
import {Analytics} from '../../../services/analytics';
import {propagateErrorsContext} from '../../../util/errors';
import {BaseTriggerDrawerInit} from './CreateTriggerDrawer/EventStore';
import {TriggersTable} from './TriggersTable/TriggersTable';

type AutomationsTabProps = {
  entityName: string;
  projectName: string;
  baseTriggerDrawerInit: BaseTriggerDrawerInit;
  readOnly: boolean;
  projectOnly?: boolean;
};

export const AutomationsTab = ({
  entityName,
  projectName,
  baseTriggerDrawerInit,
  readOnly,
  projectOnly = false,
}: AutomationsTabProps) => {
  const location = useLocation();

  // Analytics: fire once on arrival
  useEffect(() => {
    Analytics.track('Automations Tab Viewed', {
      type: 'page_view',
      page: 'automations',
      location: location.pathname,
      entityName,
      projectName,
    });
    // Only track on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const projectTriggersQuery = useFetchProjectTriggersQuery({
    variables: {projectName, entityName, projectOnly},
    context: propagateErrorsContext(),
  });
  return (
    <TriggersTable
      projectTriggersQuery={projectTriggersQuery}
      baseTriggerDrawerInit={baseTriggerDrawerInit}
      readOnly={readOnly}
    />
  );
};
